import { render, staticRenderFns } from "./ReasonsToConnect.vue?vue&type=template&id=2f9a895f&scoped=true&"
import script from "./ReasonsToConnect.vue?vue&type=script&lang=js&"
export * from "./ReasonsToConnect.vue?vue&type=script&lang=js&"
import style0 from "./ReasonsToConnect.vue?vue&type=style&index=0&id=2f9a895f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9a895f",
  null
  
)

export default component.exports